<div class="bubble" [style.--bubble-color]="color">
    <div *ngIf="!isCluster" class="icon-wrapper">
        <!-- <img *ngIf="inputImg" [src]="img" alt="Icon" [arrowTooltip]="inputText && !isCluster ? text + ' Customers' : ''" tooltipColor="{{inputColor}}"> -->
        <img *ngIf="inputImg" [src]="img" alt="Icon">
    </div>
    <div *ngIf="isCluster" class="icon-wrapper" [style.background-color]="isHvPole ?  'lightgray' : 'white'">
        <img *ngIf="isCluster" [src]="inputImg" alt="Icon">
    </div>
</div>